import styled from "@emotion/styled";
import { FC } from "react";
import { clientEnvModule } from "@/modules/client-env";
import { isMac } from "@/domains/platform/isMac";
import { DesktopMenuButton } from "@/components/desktop/desktop-menu-button";
import { ZIndex } from "@/domains/design/constants";

export const DesktopMenuOverlay: FC = () => {
  const shouldShow = clientEnvModule.isDesktop() && !isMac();
  if (!shouldShow) return null;

  return (
    <OverlayWrapper>
      <DesktopMenuButton />
    </OverlayWrapper>
  );
};

const OverlayWrapper = styled.div({
  position: "absolute",
  top: 8,
  left: 24,
  zIndex: ZIndex.DesktopMenuOverlay,
  WebkitAppRegion: "no-drag",
  pointerEvents: "auto",
});
